<div class="backoffice-companies-container">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>id</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="employee_id">
      <th mat-header-cell *matHeaderCellDef>employee_id</th>
      <td mat-cell *matCellDef="let element">{{ element.employee_id }}</td>
    </ng-container>
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>created_at</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.created_at) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>phone</th>
      <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="cp">
      <th mat-header-cell *matHeaderCellDef>cp</th>
      <td mat-cell *matCellDef="let element">{{ element.cp }}</td>
    </ng-container>

    <ng-container matColumnDef="monthly_cowings">
      <th mat-header-cell *matHeaderCellDef>monthly_cowings</th>
      <td mat-cell *matCellDef="let element">{{ element.monthly_cowings }}</td>
    </ng-container>

    <ng-container matColumnDef="state_id">
      <th mat-header-cell *matHeaderCellDef>state_id</th>
      <td mat-cell *matCellDef="let element">{{ element.state_id }}</td>
    </ng-container>
    <ng-container matColumnDef="company_id">
      <th mat-header-cell *matHeaderCellDef>company_id</th>
      <td mat-cell *matCellDef="let element">{{ element.company_id }}</td>
    </ng-container>
    <ng-container matColumnDef="company_name">
      <th mat-header-cell *matHeaderCellDef>company_name</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>
    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef>updated_at</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.updated_at) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <div class="actions">
          <div (click)="editCoworker(element)">
            <img [src]="getEditIcon" alt="" />
          </div>
          <div (click)="deleteCoworker(element)">
            <img [src]="getDeleteIcon" alt="" />
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="20"></mat-paginator>
</div>
